import { motion } from "framer-motion";
import { FadeUp, EASE } from "./Shared";

const overlayStats = [
  { value: "LIVE", label: "MOOD INDEX BY ZONE" },
  { value: "1st", label: "URGENCY FLAGS SURFACED" },
  { value: "360°", label: "GROUND-LEVEL TRUTH" },
];

export default function VideoSection() {
  return (
    <section className="relative h-[85vh] min-h-[560px] overflow-hidden border-y border-white/10" data-testid="command-centre-video-section">
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover"
        poster="https://images.pexels.com/videos/4200101/japan-tokyo-zebra-crossing-4200101.jpeg?cs=tinysrgb&fit=crop&h=630&w=1200"
        data-testid="command-centre-video"
      >
        <source src="/videos/pulse-command-centre.mp4" type="video/mp4" />
        <source src="/videos/pulse-command-centre.webm" type="video/webm" />
      </video>
      <div className="absolute inset-0 bg-black/70" />
      <div className="scanline absolute left-0 right-0 h-px bg-[#E5FF00]/50 shadow-[0_0_18px_rgba(229,255,0,0.6)]" />
      <div className="relative h-full max-w-[1500px] mx-auto px-6 lg:px-12 flex flex-col justify-center">
        <FadeUp>
          <p className="font-mono-tech text-[11px] tracking-[0.35em] text-[#E5FF00] mb-8">THE COMMAND CENTRE</p>
          <h2 className="font-display font-black text-5xl sm:text-6xl lg:text-8xl tracking-tight leading-[0.95] max-w-4xl" data-testid="command-centre-headline">
            ONE VIEW.<br />
            <span className="text-outline">EVERY FEELING</span><br />
            ON YOUR FLOOR.
          </h2>
          <motion.p
            className="mt-8 max-w-xl text-base md:text-lg text-zinc-300 leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4, duration: 0.8, ease: EASE }}
          >
            While the crowd moves, your Command Centre reads it. LyPinn Pulse turns the flow of people through your venue
            into a living stream of sentiment — so you don't manage a space, you understand it.
          </motion.p>
        </FadeUp>
        <div className="mt-14 flex flex-wrap gap-px bg-white/10 border border-white/10 max-w-2xl">
          {overlayStats.map((s, i) => (
            <FadeUp key={s.label} delay={0.2 + i * 0.12} className="flex-1 min-w-[160px] bg-black/60 backdrop-blur-xl">
              <div className="p-6" data-testid={`command-centre-stat-${i}`}>
                <p className="font-mono-tech font-bold text-3xl text-[#E5FF00]">{s.value}</p>
                <p className="mt-2 font-mono-tech text-[9px] tracking-[0.25em] text-zinc-400">{s.label}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
